import React, { useState, useEffect } from "react";
import "./FactorKol.scss";
import Swal from "sweetalert2";
import square from "../../../Assets/svg/add-square 1.svg";
import NewTabulator from "../../NewTabulator/NewTabulator";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import _axios from "../../../httpService";
import {
  calculateSumOfEachRow,
  myCustomCelEditFunction,
  updateTableCellHandler,
} from "../Function";
import {
  formatToPersianAddComma,
  parseToEnRemoveComma,
} from "../../../utils/CommaSeparator";
import tableCalc from "../../../utils/tableCalc";

const Factorkol = (props) => {
  const { backendData, initialData, onTotalColumnSumChange } = props;

  const columns = [
    {
      title: "شماره فاکتور",
      field: "InvoiceNumber",
      // visible: initialData.typeOfServices.some((service) => service.InvoiceNumber !== ""),
    },
    { title: "نوع خدمات", field: "TypeOfService" },
    {
      title: "تعداد",
      field: "number",
      editor: "number",
      cellEdited: function (e, cell) {
        let value = e.target.value;
        if (value === "") {
          value = 1;
        }

        value = parseToEnRemoveComma(value);
        value = parseInt(value);
        myCustomCelEditFunction(sendData, setSendData, cell, "number", value);

        // Check if the entered value is a valid number, if not, set it to 0
        // const number = isNaN(value) ? 0 : parseFloat(value);
        const data = cell.getData();
        const amount = parseFloat(data.AmountOfService);
        const price = amount * value;

        setSendData((prevData) => ({
          ...prevData,
          tableData: prevData.tableData.map((row) =>
            row.TypeOfService === data.TypeOfService
              ? {
                  ...row,
                  price: price.toString(),
                }
              : row
          ),
        }));

        setReload(!reload);
      },
      formatter: tableCalc.separateNumbers,
    },
    {
      title: "مبلغ خدمات",
      field: "AmountOfService",
      editor: "number",
      cellEdited: function (e, cell) {
        let value = e.target.value;
        if (value === "") {
          
          value = 0;
        }

        value = parseToEnRemoveComma(value);
        value = parseInt(value);
        myCustomCelEditFunction(
          sendData,
          setSendData,
          cell,
          "AmountOfService",
          value
        );

        // Check if the entered value is a valid number, if not, set it to 0
        // const amount = isNaN(value) ? 0 : parseFloat(value);
        const data = cell.getData();
        const number = parseFloat(data.number);
        const price = value * number;

        setSendData((prevData) => ({
          ...prevData,
          tableData: prevData.tableData.map((row) =>
            row.TypeOfService === data.TypeOfService
              ? {
                  ...row,
                  price: price.toString(),
                }
              : row
          ),
        }));

        setReload(!reload);
      },
      formatter: tableCalc.separateNumbers,
    },
    {
      title: "جمع",
      field: "price",
      // , bottomCalc: tableCalc.sum,
      formatter: tableCalc.separateNumbers,
    },
    {
      title: "حذف",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItem: "center",
        justifyContent: "center",
      },
      justifyContent: "center",
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        const row = cell.getData();
        console.log("حذف حذف حذف", row);
        handleDeleteRow(row); // Pass the row data to the handleDeleteRow function
      },
    },
  ];

  const [reload, setReload] = useState(false);

  const [selectedService, setSelectedService] = useState("");

  const [sendData, setSendData] = useState({ tableData: [] });

  const [totalColumnSum, setTotalColumnSum] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();

    // اطلاعات را در لوکال استوریج ذخیره کنید
    localStorage.setItem("selectedService", JSON.stringify(selectedService));

    // پاک کردن فیلدها
    setSelectedService("");
  };

  const handleDeleteRow = (row) => {
    Swal.fire({
      title: "آیا مطمئن هستید؟",
      text: "شما نمی‌توانید این عملیات را بازگردانی کنید!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "حذف",
      cancelButtonText: "لغو",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedTableData = sendData.tableData.filter(
          (item) => item.TypeOfService !== row.TypeOfService
        );

        setSendData((prevData) => ({
          ...prevData,
          tableData: updatedTableData,
        }));
      }
    });
  };

  const addRowToTable = () => {
    if (selectedService) {
      const selectedServiceItem = initialData.typeOfServices.find(
        (item) => item.value === selectedService
      );

      if (selectedServiceItem) {
        // Generate a unique key based on the selected service type
        const uniqueKey = `${selectedService}`;

        const newRow = {
          value: uniqueKey, // Add the unique key to the row
          InvoiceNumber: selectedServiceItem.InvoiceNumber,
          TypeOfService: selectedServiceItem.label,
          AmountOfService: String(selectedServiceItem.price),
          number: "1",
          price: String(selectedServiceItem.price),
          recordId: "",
        };

        // Check if a row with the same service type already exists
        const existingRow = sendData.tableData.find(
          (row) => row.TypeOfService === newRow.TypeOfService
        );

        if (existingRow) {
          // Increment the number and update the sum for the existing row
          existingRow.number = String(parseInt(existingRow.number) + 1);
          existingRow.price = String(
            parseFloat(existingRow.price) + parseFloat(newRow.AmountOfService)
          );
        } else {
          // Add the new row to the tableData array
          setSendData((prevData) => ({
            ...prevData,
            tableData: [...prevData.tableData, newRow],
          }));
        }

        setSelectedService("");
      }
    } else {
      alert("Please select a service type before adding.");
    }
  };

  const calculateTotalColumnSum = (data) => {
    let price = 0;
    data.forEach((row) => {
      const amount = row.AmountOfService || 0;
      const number = row.number || 0;
      const rowSum = amount * number;
      price += rowSum;
    });
    return price;
  };

  useEffect(() => {
    setSendData({ tableData: calculateSumOfEachRow(sendData.tableData) });
  }, [reload]);

  useEffect(() => {
    if (sendData.tableData) {
      const price = calculateTotalColumnSum(sendData.tableData);
      setTotalColumnSum(price);
      // Call the onTotalColumnSumChange function to update the state in the parent component
      onTotalColumnSumChange(price);
      props.onRecordDataChange(sendData.tableData);
    }
  }, [sendData.tableData]);

  useEffect(() => {
    if (backendData.factorDetail !== undefined) {
      if (backendData.factorDetail.length > 0) {
        setSendData({ ...sendData, tableData: backendData.factorDetail });
      }
    }
  }, [backendData.factorDetail]);

  debugger;
  return (
    <div className="Factorkoli">
      <div className="topOfTable">
        <form onSubmit={handleSubmit}>
          <div className="TypeOfService">
            <label>نوع خدمات</label>
            <select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
            >
              <option value="">نوع خدمات را انتخاب کنید</option>
              {initialData.typeOfServices !== undefined &&
                initialData.typeOfServices.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </div>
        </form>
        <button
          type="button"
          className="btn btnCustom btnSubmit"
          onClick={addRowToTable}
        >
          <img src={square} alt="" />
        </button>
      </div>
      <div className="tableAndBtn">
        <div id="print-section" className="Factor-table">
          <NewTabulator
            columns={columns}
            data={sendData.tableData} // Update data prop here
            style={{ height: "50vh", overflowY: "scroll" }}
            className={"header__color__F1F1F1"}
          />
        </div>
        <div className="borderUnderTable">
          <div className="border"></div>
        </div>
        <div className="DeleteFactorAndBtn">
          <div className="btnSum">
            <span>جمع خدمات</span>
            <span className="sumNum">
              {formatToPersianAddComma(totalColumnSum)} ریال
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Factorkol;
